/**
 * Demo mode: the hooks serve their `*.mock.ts` fixtures instead of calling the
 * API, so the app can be shown without a tenant behind it.
 *
 * `?demo=1` turns it on and it sticks — the visitor navigates, and a query
 * string does not survive that. `?demo=0` is the way back out. Its home is
 * here rather than in one of the mock files it used to be copied into, nine
 * times over.
 */
export function isDemoMode(): boolean {
  if (typeof window === "undefined") return false;

  const params = new URLSearchParams(window.location.search);
  const demoParam = params.get("demo");

  // If ?demo=1 is in URL, store in localStorage
  if (demoParam === "1") {
    localStorage.setItem("demo_mode", "1");
    return true;
  }

  // If ?demo=0 is in URL, clear from localStorage
  if (demoParam === "0") {
    localStorage.removeItem("demo_mode");
    return false;
  }

  // Otherwise, check localStorage
  return localStorage.getItem("demo_mode") === "1";
}
